import { render, staticRenderFns } from "./ProductsInTestImport.vue?vue&type=template&id=0e56c093"
import script from "./ProductsInTestImport.vue?vue&type=script&lang=js"
export * from "./ProductsInTestImport.vue?vue&type=script&lang=js"
import style0 from "./ProductsInTestImport.vue?vue&type=style&index=0&id=0e56c093&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports